import store from "@/store";
import numberFormatter from "number-formatter";

export default function giftcardCurrency(value) {
  let n_value = parseFloat(value);
  if (isNaN(n_value)) {
    return value;
  }

  let giftcardAmountFormat = store.getters.giftcardAmountFormat;
  if (giftcardAmountFormat) {
    return numberFormatter(giftcardAmountFormat, n_value);
  } else {
    let style = "currency";
    let minimumFractionDigits = 2;

    var formatter = new Intl.NumberFormat("en-CA", {
      style: style,
      currency: "CAD",
      minimumFractionDigits: minimumFractionDigits,
    });
    return formatter.format(n_value);
  }
}
